{
    "poolsMicroserviceURL": "https://vuecapacityprodafd.azurefd.net/v1/",
    "capacityMicroserviceURL": "https://vuecapacityprodafd.azurefd.net/v1/",
    "pageTitleSuffix": ""
}